import {
  DetailPickerTagFileType,
  PickerVehicleDataFilesType,
} from "pages/pickers/types";
import { DashboardDropdownState } from "reducers/types/dashboardSlotCapacityModal";
import { RainDropDownState, RainTypes } from "reducers/types/rainModal";
import { CountryCodeType } from "reducers/types/session";
import { EditPreliType } from "sagas/types/preliquidation";
import { ShiftType } from "sagas/types/slots";
import { TransactionStatusType } from "sagas/types/transactions";

export const VERSION = '2.37.1';

export const COUNTRIES = ["AR", "CO", "MX", "CL"] as const;
export const PICKIT_COUNTRIES = ["AR", "CO", "MX", "PE", "UY", "CL"] as const;

export const titlesAdminPending: { label: string; id: string }[] = [
  {
    label: "tablePickers:name",
    id: "name",
  },
  {
    label: "tablePickers:identifier",
    id: "identifier",
  },
  {
    label: "tablePickers:email",
    id: "email",
  },
  {
    label: "tablePickers:vehicle",
    id: "vehicle",
  },
  {
    label: "tablePickers:pending",
    id: "pending",
  },
  {
    label: "tablePickers:edit",
    id: "edit",
  },
];

export const titlesAdminActive: { label: string; id: string }[] = [
  {
    label: "tablePickers:name",
    id: "name",
  },
  {
    label: "tablePickers:identifier",
    id: "identifier",
  },
  {
    label: "tablePickers:email",
    id: "email",
  },
  {
    label: "tablePickers:vehicle",
    id: "vehicle",
  },
  {
    label: "tablePickers:status",
    id: "status",
  },
  {
    label: "tablePickers:edit",
    id: "edit",
  },
];

export const transactionTableTitles: { label: string; id: string }[] = [
  {
    id: "transaction",
    label: "tableTransactions:transaction",
  },
  {
    id: "order-number",
    label: "tableTransactions:orderNumber",
  },
  {
    id: "picker-id",
    label: "tableTransactions:pickerId",
  },
  {
    id: "trip",
    label: "tableTransactions:trip",
  },
  {
    id: "sla-expiration",
    label: "tableTransactions:dateAndHour",
  },
  {
    id: "status",
    label: "tableTransactions:status",
  },
];

export const workzonesTableTitles: { label: string; id: string }[] = [
  {
    id: "date",
    label: "workzonesTable:date",
  },
  {
    id: "time",
    label: "workzonesTable:time",
  },
  {
    id: "workzone",
    label: "workzonesTable:workzone",
  },
  {
    id: "maxQuantity",
    label: "workzonesTable:maxQuantity",
  },
];

export const preliquidationsTableTitles: { label: string; id: string }[] = [
  {
    id: "preliNumber",
    label: "tablePresettlements:preliNumber",
  },
  {
    id: "if",
    label: "tablePresettlements:if",
  },
  {
    id: "dateOfIssue",
    label: "tablePresettlements:dateOfIssue",
  },
  {
    id: "status",
    label: "tablePresettlements:status",
  },
  {
    id: "total",
    label: "tablePresettlements:total",
  },
];

export const slotsDetailTableTitles: { label: string; id: string }[] = [
  {
    id: "region",
    label: "tableSlots:region",
  },
  {
    id: "workzone",
    label: "tableSlots:workzone",
  },
  {
    id: "capacity",
    label: "tableSlots:capacity",
  },
  {
    id: "shift",
    label: "tableSlots:shift",
  },
  {
    id: "date",
    label: "tableSlots:date",
  },
];

export const slotsTemplatesTableTitles: { label: string; id: string }[] = [
  {
    id: "region",
    label: "tableTemplates:region",
  },
  {
    id: "workzone",
    label: "tableTemplates:workzone",
  },
  {
    id: "shift",
    label: "tableTemplates:shift",
  },
  {
    id: "frecuency",
    label: "tableTemplates:frecuency",
  },
  {
    id: "updatedAt",
    label: "tableTemplates:updatedAt",
  },
];

export const tiersTableTitles: { label: string; id: string }[] = [
  {
    id: "tierName",
    label: "polygonPricing:tierName",
  },
  {
    id: "tierBase",
    label: "polygonPricing:tierBase",
  },
  {
    id: "tierPrice",
    label: "polygonPricing:tierPrice",
  },
];

export const cancelStatus = [
  "state_pickup_cancelled_temporally",
  "state_pickup_cancelled_permanently",
  "state_lost",
];

export const DATE_FORMATS = {
  regex:
    /^(?:(?:31(\/|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/,
  regexshortDate:
    /^(?:(?:31(\/|\/|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|\/|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|\/|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|\/|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/,
  regexValidCharacter: /^[0-9]/,
  fullISODate: "YYYY-MM-DD hh:mm:ss",
  fullHour: "HH:mm:ss",
  shortHour: "HH:mm",
  extraShortDate: "DD/MM/YY",
  shortDate: "DD/MM/YYYY",
  shortISODate: "YYYY-MM-DD",
};

export const VALIDATION_REGEX = {
  expName:
    /^[a-zA-ZàáäãâåèéêëìíîïòóôöõøùúüÿýñçšžÀÁÄÃÅÈÉÊËÌÍÎÏÒÓÔÖÕØÙÚÜŸÝŽÑŠßÇðŒÆ,.'-][a-zA-ZàáäãâåèéêëìíîïòóôöõøùúüÿýñçšžÀÁÄÃÅÈÉÊËÌÍÎÏÒÓÔÖÕØÙÚÜŸÝŽÑŠßÇðŒÆ ,.'-]*$/u,
  regArea: /^([0-9]){1,5}$/,
  regTelefono: /^([0-9]){6,10}$/,
  regPatent: /^([a-zA-Z]{1}[0-9]{3}[a-zA-Z]{3}|[0-9]{3}[a-zA-Z]{3})*$/,
  regPatentCO: /^[a-zA-Z]{3}[0-9]{2}[a-zA-Z]{1}$/,
  regPatentMX: /^([0-9][a-zA-Z]){2}[a-zA-Z]$/,
  regTransactionCode: /^[a-fA-F0-9]*$/,
  regTripCode: /^[a-fA-F0-9]{1-10}$/,
  regPickerId: /^[0-9]*$/,
  regEmail:
    /(?=.*[a-zA-Z])(?=^.{1,64}$)^[a-zA-Z\d](?:(\.|[-_]+)?[a-zA-Z\d])*(?:(\+)[a-zA-Z\d]+)?(?:(\.)[a-zA-Z\d]+)*[\da-zA-Z-_]*@(?:[a-zA-Z\d](?:[-a-zA-Z\d]+)?\.)+[a-zA-Z\d](?:[a-zA-Z\d]+){1,}?$/,
  regPassword:
    /^(?=.*[a-zàáèéìíòóùúñ])(?=.*[A-ZÀÁÈÉÌÍÒÓÙÚÑ])(?=.*\d)[A-Za-z\dàáèéìíòóùúñÀÁÈÉÌÍÒÓÙÚÑ@$¡!%;,*.?#^=&_-]{8,20}$/,
  regPasswordSpecialCharacters:
    /^[0-9A-Za-zdàáèéìíòóùúñÀÁÈÉÌÍÒÓÙÚÑ@$¡!%;,*.?#^=&_-]*$/,
  regMayMin: /^(?=.{1,})(?=.*[a-zdàáèéìíòóùúñ])(?=.*[A-ZÀÁÈÉÌÍÒÓÙÚÑ]).*$/,
  regLetNum: /^(?=.{1,})(?=.*[a-zA-ZdàáèéìíòóùúñÀÁÈÉÌÍÒÓÙÚÑ])(?=.*[0-9]).*$/,
  regDNI: /^[0-9]*$/,
  regRUN: /^\d{7,8}-[kK0-9]$/,
  regRUT: /^\d{7,8}[kK0-9]$/,
  regNumber: /^[0-9]*$/,
  sapInterlocutorTenDigits: /^[0-9]{10}$/,
  identificationNumber: /^[A-Za-z0-9]{6,15}$/,
  identificationNumberCC: /^[0-9]{6,15}$/,
  lettersAndNumbers: /^[a-zA-Z0-9]*$/,
  regStreet:
    /^[0-9A-Za-zàáäãâåèéêëìíîïòóôöõøùúüÿýñçšžÀÁÄÃÅÈÉÊËÌÍÎÏÒÓÔÖÕØÙÚÜŸÝŽÑŠßÇðŒÆ ,.'-/º°#]*$/,
  regInvoiceMX: /^[A-Za-z0-9]{8}(-[A-Za-z0-9]{4}){3}-[A-Za-z0-9]{12}$/,
  regInvoiceMX2: /^[a-zA-Z0-9-]*$/,
  regCURP: /^[a-zA-Z]{4}\d{6}[a-zA-Z]{6}(\d|[a-zA-Z])\d$/,
  regRFC: /^[a-zA-Z]{4}\d{6}[a-zA-Z\d]{3}$/,
};

export const FILTER_TRANSACTION_OPTIONS = [
  {
    label: "filterTransactions:notAssigned",
    id: "PENDING_ASSIGNMENT",
  },
  {
    label: "filterTransactions:inPickup",
    id: "IN_PICK_UP",
  },
  {
    label: "filterTransactions:inPickupPoint",
    id: "IN_PICK_UP_POINT",
  },
  {
    label: "filterTransactions:inDelivery",
    id: "IN_DELIVERY",
  },
  {
    label: "filterTransactions:inDeliveryPoint",
    id: "IN_DELIVERY_POINT",
  },
  {
    label: "filterTransactions:delivered",
    id: "DELIVERED",
  },
  {
    label: "filterTransactions:inReturnToSender",
    id: "IN_RETURN_TO_SENDER",
  },
  {
    label: "filterTransactions:returnedToSender",
    id: "RETURNED_TO_SENDER",
  },
  {
    label: "filterTransactions:lost",
    id: "LOST",
  },
  {
    label: "filterTransactions:cancel",
    id: "CANCEL",
  },
];

export const COLLECTED_TRANSACTIONS_STATES: TransactionStatusType[] = [
  "IN_DELIVERY",
  "IN_DELIVERY_POINT",
  "IN_RETURN_TO_SENDER",
];

export const ASSIGNED_TRANSACTIONS_STATES: TransactionStatusType[] = [
  ...COLLECTED_TRANSACTIONS_STATES,
  "IN_PICK_UP",
  "IN_PICK_UP_POINT",
];

export const PENDING_ASSIGNMENT_STATES: TransactionStatusType[] = [
  "PENDING_ASSIGNMENT",
];

export const ACTIVE_TRANSACTIONS_STATES: TransactionStatusType[] = [
  ...ASSIGNED_TRANSACTIONS_STATES,
  ...PENDING_ASSIGNMENT_STATES,
];

export const PRELIQUIDATION_STATUS_TAGS = [
  "INITIAL",
  "PENDING",
  "IN_APPROVEMENT",
  "APPROVED",
  "REGULATORY_VALIDATION_FAILED",
  "PENDING_ACCOUNTING",
  "IN_ACCOUNTING",
  "GENERATED_PAYMENT",
  "INVOICE_REJECTED",
] as const;

export type PreliquidationStatusTags =
  (typeof PRELIQUIDATION_STATUS_TAGS)[number];

export const PRELIQUIDATION_STATUS_NAMES: {
  [key in PreliquidationStatusTags]: string;
} = {
  APPROVED: "filterPresettlements:approved",
  GENERATED_PAYMENT: "filterPresettlements:generated_payment",
  IN_ACCOUNTING: "filterPresettlements:in_accounting",
  IN_APPROVEMENT: "filterPresettlements:in_approvement",
  INITIAL: "filterPresettlements:initial",
  INVOICE_REJECTED: "filterPresettlements:invoice_rejected",
  PENDING: "filterPresettlements:pending",
  PENDING_ACCOUNTING: "filterPresettlements:pending_accounting",
  REGULATORY_VALIDATION_FAILED: "filterPresettlements:regulatory_validation_failed",
};

export const PRELIQUIDATION_STATUS: {
  [key in PreliquidationStatusTags]: PreliquidationStatusTags;
} = {
  APPROVED: "APPROVED",
  GENERATED_PAYMENT: "GENERATED_PAYMENT",
  IN_ACCOUNTING: "IN_ACCOUNTING",
  IN_APPROVEMENT: "IN_APPROVEMENT",
  INITIAL: "INITIAL",
  INVOICE_REJECTED: "INVOICE_REJECTED",
  PENDING: "PENDING",
  PENDING_ACCOUNTING: "PENDING_ACCOUNTING",
  REGULATORY_VALIDATION_FAILED: "REGULATORY_VALIDATION_FAILED",
};

export const getFilterPreliquidationOptions = (countryCode: string) =>
  PRELIQUIDATION_STATUS_TAGS
    .filter((status) => countryCode === "AR" || status !== "REGULATORY_VALIDATION_FAILED")
    .map((status) => ({ label: PRELIQUIDATION_STATUS_NAMES[status], id: status }));

export type VehicleTagType = "BICYCLE" | "MOTORCYCLE" | "4_WHEELS";

export const VEHICLE_TAGS: { [key in VehicleTagType]: VehicleTagType } = {
  BICYCLE: "BICYCLE",
  MOTORCYCLE: "MOTORCYCLE",
  "4_WHEELS": "4_WHEELS",
};

export const FILTER_PICKERS_OPTIONS = [
  {
    label: "filterPickers:bicycle",
    value: VEHICLE_TAGS.BICYCLE,
  },
  {
    label: "filterPickers:motorcycle",
    value: VEHICLE_TAGS.MOTORCYCLE,
  },
  {
    label: "filterPickers:wheels_4",
    value: VEHICLE_TAGS["4_WHEELS"],
  },
];

export const MOTORIZED_VEHICLES_TAGS: VehicleTagType[] = [
  VEHICLE_TAGS.MOTORCYCLE,
  VEHICLE_TAGS["4_WHEELS"],
];

export const PICKERS_TABS = {
  pickers: "pickers",
  pending: "pending",
};

export const PICKERS_STATUS = {
  enabled: "ENABLED",
  disabled: "DISABLED",
  pending: "PENDING_APPROVAL",
  inCorrection: "IN_CORRECTION",
  incomplete: "INCOMPLETE",
};

export const PENDING_PICKER_STATUS = [
  PICKERS_STATUS.pending,
  PICKERS_STATUS.inCorrection,
];

export const ACTIVE_PICKER_STATUS = [
  PICKERS_STATUS.enabled,
  PICKERS_STATUS.disabled,
  PICKERS_STATUS.incomplete,
];

export const TRANSACTION_STATE_ID_LABEL: { [key: number]: string } = {
  1: "filterTransactions:notAssigned",
  2: "filterTransactions:assigned",
  3: "filterTransactions:inPickup",
  4: "filterTransactions:inPickupPoint",
  5: "filterTransactions:retired",
  6: "filterTransactions:inDelivery",
  7: "filterTransactions:inDeliveryPoint",
  8: "filterTransactions:inReturnToSender",
  9: "filterTransactions:cancel",
  10: "filterTransactions:delivered",
  11: "filterTransactions:returnedToSender",
  12: "filterTransactions:lost",
};

export const TRANSACTION_STATE_TAG_LABEL: {
  [k in TransactionStatusType]: string;
} = {
  PENDING_ASSIGNMENT: "filterTransactions:notAssigned",
  ASSIGNED: "filterTransactions:assigned",
  IN_PICK_UP: "filterTransactions:inPickup",
  IN_PICK_UP_POINT: "filterTransactions:inPickupPoint",
  PICKED_UP: "filterTransactions:retired",
  IN_DELIVERY: "filterTransactions:inDelivery",
  IN_DELIVERY_POINT: "filterTransactions:inDeliveryPoint",
  IN_RETURN_TO_SENDER: "filterTransactions:inReturnToSender",
  CANCEL: "filterTransactions:cancel",
  DELIVERED: "filterTransactions:delivered",
  RETURNED_TO_SENDER: "filterTransactions:returnedToSender",
  LOST: "filterTransactions:lost",
  PLUS: "detailPresettlement:plus",
  SUBTRACT: "detailPresettlement:subtract",
};

export const TRANSACTION_ACTIONS_TAG_LABEL: { [key: string]: string } = {
  assigned_picker: "filterTransactions:assigned",
  un_assigning: "filterTransactions:pendingAssignment",
  state_pending_assigment: "filterTransactions:pendingAssignment",
  state_assigned: "filterTransactions:assigned",
  state_in_pickup: "filterTransactions:inPickup",
  state_in_pickup_point: "filterTransactions:inPickupPoint",
  state_in_picked_up: "filterTransactions:retired",
  state_in_delivery: "filterTransactions:inDelivery",
  state_in_delivery_point: "filterTransactions:inDeliveryPoint",
  state_in_devolution: "filterTransactions:inReturnToSender",
  state_pickup_cancelled_temporally: "filterTransactions:cancel",
  state_pickup_cancelled_permanently: "filterTransactions:cancel",
  state_delivered: "filterTransactions:delivered",
  state_returned: "filterTransactions:returnedToSender",
  state_lost: "filterTransactions:lost",
  state_initial: "filterTransactions:created",
};

export const PRELIQUIDATION_HISTORY_STATES: { [key: string]: string } = {
  STATE_INITIAL: "presettlement:initialState",
  STATE_PENDING: "presettlement:pending",
  STATE_IN_APPROVEMENT: "presettlement:inApprovement",
  STATE_APPROVED: "presettlement:approved",
  STATE_PENDING_ACCOUNTING: "presettlement:pendingAcounting",
  STATE_IN_ACCOUNTING: "presettlement:inAcounting",
  STATE_GENERATED_PAYMENT: "presettlement:generatedPayment",
  STATE_INVOICE_REJECTED: "presettlement:invoiceRejected",
  ADJUSTMENT: "presettlement:adjustment",
  WEEKLY: "presettlement:weekly",
  DAILY: "presettlement:daily",
  ASSURED: "presettlement:assured",
  STATE_REGULATORY_VALIDATION_FAILED: "presettlement:regulatoryValidationFailed",
};

export const DETAIL_PICKER_TAG: DetailPickerTagFileType = {
  "dni-front": "picker:dniFront",
  "dni-back": "picker:dniBack",
  "user-face": "picker:userFace",
  "criminal-record-certificate": "picker:criminalRecordCertificate",
  "cbu-certificate": "picker:cbuCertificate",
  "cuit-certificate": "picker:cuitCertificate",
  "driver-license": "picker:driverLicense",
  "vehicle-identification-back": "picker:vehicleIdentificationBack",
  "vehicle-identification-front": "picker:vehicleIdentificationFront",
  "driver-insurance-card": "picker:driverInsuranceCard",
  "infraction-record": "picker:infractionRecord",
};

export const VEHICLE_MOTORIZED_DOCUMENT_TAGS: readonly PickerVehicleDataFilesType[] =
  [
    "driver-license",
    "vehicle-identification-front",
    "vehicle-identification-back",
    "driver-insurance-card",
  ];

export const VEHICLE_MOTORIZED_DOCUMENT_NAMES: Pick<
  typeof DETAIL_PICKER_TAG,
  | "driver-license"
  | "vehicle-identification-front"
  | "vehicle-identification-back"
  | "driver-insurance-card"
> = {
  "driver-license": DETAIL_PICKER_TAG["driver-license"],
  "vehicle-identification-front":
    DETAIL_PICKER_TAG["vehicle-identification-front"],
  "vehicle-identification-back":
    DETAIL_PICKER_TAG["vehicle-identification-back"],
  "driver-insurance-card": DETAIL_PICKER_TAG["driver-insurance-card"],
};

export const PRELIQUIDATION_TRANSACTIONS_LABELS = [
  "presettlement:id",
  "presettlement:date",
  "presettlement:detailAmount",
  "presettlement:status",
  "presettlement:amount",
];

export const INVOICE_REJECT_REASONS: { [k in string]: string } = {
  MNM100: "rejectInvoice:amountReason",
  EBS200: "rejectInvoice:companyNameReason",
  OTH300: "rejectInvoice:otherReason",
};

export const MAX_FILE_SIZE = 5000000;
export const PICKERS_MAX_FILE_SIZE = MAX_FILE_SIZE;
export const FILE_EXT_INVOICE = ["application/pdf", "image/png", "image/jpg"];
export const FILE_EXT = [...FILE_EXT_INVOICE, "image/jpeg"];

export const PRELIQUIDATION_STATUS_OK = [200, 201, 204];

export const FIRST_ANIMATION_TIME = 1500;
export const BULK_FLOW_ID = "approvement";
export const TIMEZONES: { [k in CountryCodeType]: number } = {
  AR: -3,
  CO: -5,
  MX: -6,
  CL: -4,
};

export const TAX_PAYER_TYPES: { [k in string]: string } = {
  MONOTRIBUTISTA: "invoice:monotributist",
  PERSONA_NATURAL: "invoice:naturalPerson",
  PERSONA_FISICA: "invoice:fisicalPerson",
  PRIMERA_CATEGORIA: "invoice:firstCategory",
};

export const TIERS_ERRORS: { [key: string]: string } = {
  REQUIRED_ERROR: "1",
  POSITIVE_ERROR: "2",
  GENERIC_ERROR: "3",
};

export const RAIN_TYPES: { [key: string]: RainTypes } = {
  next: "NEXT",
  previous: "PREVIOUS",
};

export const OPPOSE_RAIN_TYPES: { [key: string]: RainDropDownState } = {
  next: "previous",
  previous: "next",
};

export const EDIT_PRELI = ["PLUS", "SUBTRACT"] as const;

export const EDIT_PRELI_AMOUNT: { [k in EditPreliType]: EditPreliType } = {
  PLUS: "PLUS",
  SUBTRACT: "SUBTRACT",
};

export const DETAIL_PRICING_TAGS = [
  "COLLECT_KM",
  "COLLECT",
  "DELIVERED_KM",
  "DELIVERED",
  "RETURNED_KM",
  "RETURNED",
  "RAIN",
] as const;

export type DetailPricingTagType = (typeof DETAIL_PRICING_TAGS)[number];

export const DETAIL_PRICING_TRANSACTIONS_TAGS: {
  [key in DetailPricingTagType]: DetailPricingTagType;
} = {
  COLLECT_KM: "COLLECT_KM",
  COLLECT: "COLLECT",
  DELIVERED_KM: "DELIVERED_KM",
  DELIVERED: "DELIVERED",
  RETURNED_KM: "RETURNED_KM",
  RETURNED: "RETURNED",
  RAIN: "RAIN",
};

export const DETAIL_PRICING_TRANSACTIONS: {
  [key in DetailPricingTagType]: string;
} = {
  COLLECT_KM: "presettlement:extraPickUpKm",
  COLLECT: "presettlement:pickUp",
  DELIVERED_KM: "presettlement:extraDeliveredKm",
  DELIVERED: "presettlement:delivered",
  RETURNED_KM: "presettlement:extraReturnedKm",
  RETURNED: "presettlement:returned",
  RAIN: "presettlement:rainBonus",
};

export const PRELI_TRANSACTIONS_DETAILS_KM_TYPES = [
  "COLLECT_KM",
  "DELIVERED_KM",
  "RETURNED_KM",
];

export const PRELI_TRANSACTIONS_ADJUSTMENT_PRESET_REASONS = [
  "Premio diario",
  "Premio semanal",
  "Asegurado por turno",
];

export enum CANCEL_TRANSATIONS_IDS {
  bySeller = 7,
  byAdmin,
}

export const SLOTS_SHIFTS: ShiftType[] = [
  {
    tag: "MORNING",
    description: "Mañana",
  },
  {
    tag: "AFTERNOON",
    description: "Tarde",
  },
];

export const PICKER_STATE_OPTIONS = [
  {
    name: "filterPickers:enabled",
    id: PICKERS_STATUS.enabled,
  },
  {
    name: "filterPickers:disabled",
    id: PICKERS_STATUS.disabled,
  },
  {
    name: "filterPickers:incomplete",
    id: PICKERS_STATUS.incomplete,
  },
];
export const FISCAL_NUMBER_LENGTH: { [key in CountryCodeType]: number } = {
  AR: 11,
  CO: 12,
  MX: 13,
  CL: 9,
};

export const PICKER_ACCOUNT_DATA_FILES_TYPE = [
  "cbu-certificate",
  "cuit-certificate",
] as const;

export const PICKER_ACCOUNTING_REQUIRED_FILE_TAGS = [
  "cbu-certificate",
] as const;

export const DASHBOARD_TABLES_LIMIT = 10;

export const CAPACITY_DETAIL_PARAM_TABS: {
  [key in DashboardDropdownState]: string;
} = {
  withTrx: "with-trx",
  withoutTrx: "without-trx",
  disconnected: "disconnected",
};

export const DAYS_LIMIT = 7;

export const viewResults = [
  {
    id: 10,
    name: "10",
  },
  {
    id: 25,
    name: "25",
  },
  {
    id: 50,
    name: "50",
  },
  {
    id: 100,
    name: "100",
  },
];

export const TRANSACTION_STATE_TAG = {
  PENDING_ASSIGNMENT: "PENDING_ASSIGNMENT",
  ASSIGNED: "ASSIGNED",
  IN_PICK_UP: "IN_PICK_UP",
  IN_PICK_UP_POINT: "IN_PICK_UP_POINT",
  PICKED_UP: "PICKED_UP",
  IN_DELIVERY: "IN_DELIVERY",
  IN_DELIVERY_POINT: "IN_DELIVERY_POINT",
  IN_RETURN_TO_SENDER: "IN_RETURN_TO_SENDER",
  CANCEL: "CANCEL",
  DELIVERED: "DELIVERED",
  RETURNED_TO_SENDER: "RETURNED_TO_SENDER",
  LOST: "LOST",
};

export enum TRANSACTION_CANCELLATION_REASON {
  POINT_HAS_NO_PACKAGE = 1,
  POINT_IS_CLOSED,
  COLLECTION_POINT_NOT_FOUND,
  DAMAGED_WRAPPER,
  EXCESSIVE_VOLUME_OR_WEIGHT,
  PERSONAL_OR_TRANSPORTATION_REASONS,
  CANCELLED_BY_SELLER,
  CANCELLED_BY_ADMIN,
  POINT_HAS_NO_SERVICE,
  DO_NOT_WANT_THE_TRIP,
}
